const SDK_VERSION = '7.56.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
